export default __webpack_public_path__ + "static/media/overview_banner_image.d2b1083e.png";